const product = {
  Bmw: [
    {
      id: 32,
      name: "2015 BMW X6",
      feature: "2015 BMW X6 Black body with Tan + Black interior.",
      description: "2015 BMW X6 Sporty luxury SUV coupe with powerful engine options, AWD, premium leather interior, advanced tech, and dynamic handling. Stylish and performance-driven.",
      image: "bmw/bmw_1.jpg",
      tumb1: "bmw/bmw_2.jpg",
      tumb2: "bmw/bmw_3.jpg",
      tumb3: "bmw/bmw_4.jpg"
    }
  ],

  Honda: [
    {
      id: 30,
      name: "2017 Honda Pilot EX-L",
      feature: "2017 Honda Pilot EX-L w/ Honda Sensing Sport Utility 4D White exterior.",
      description: "2017 Honda Pilot EX-L Spacious 3-row SUV with V6 power, leather seats, sunroof, power tailgate, and Honda Sensing safety features. Smooth ride, great for families and long trips.",
      image: "honda/HondaPilot2017_1.jpg",
      tumb1: "honda/HondaPilot2017_2.jpg",
      tumb2: "honda/HondaPilot2017_3.jpg",
      tumb3: "honda/HondaPilot2017_4.jpg"
    
    },
  ],
  Lexus: [
    {
      id: 26,
      name: "2010 Lexus GX",
      feature: "2010 Lexus GX- Gold Exterior, Beige Interior Smooth, spacious, and ready for Nigerian roads.",
      description: "2010 Lexus GX 460 Luxury 7-passenger SUV with 4WD, powerful V8 engine, premium interior, advanced safety, and off-road capability. Smooth, quiet ride with Lexus reliability.",
      image: "lexus/lexusgx_1.jpg",
      tumb1: "lexus/lexusgx_2.jpg",
      tumb2: "lexus/lexusgx_3.jpg",
      tumb3: "lexus/lexusgx_4.jpg"
    
    },
    {
      id: 27,
      name: "Lexus GX 460 Premium Sport Utility 4D",
      feature: " Lexus GX 460 Premium Sport Utility 4D in pristine white Luxury meets durability  perfect for Nigerian roads..",
      description: "Lexus GX 460 Premium 4D SUV Luxury 4WD SUV with V8 power, leather seats, navigation, sunroof, heated/cooled seats, and third-row seating. Smooth, capable, and built for comfort on or off-road.",
      image: "lexus460/lexus460_1.jpg",
      tumb1: "lexus460/lexus460_2.jpg",
      tumb2: "lexus460/lexus460_3.jpg",
      tumb3: "lexus460/lexus460_4.jpg"
    
    },
  ],
  Toyota: [
    {
      id: 1,
      name: "2017 Toyota Highlander ",
      feature: "2017 Toyota Highlander Grey Exterior, Grey Interior Smooth, spacious, and ready for Nigerian roads.",
      description:
        "2017 Toyota Highlander The 2017 Toyota Highlander is a reliable and family-friendly midsize SUV with seating for up to eight. It features a strong V6 engine, available all-wheel drive, and advanced safety tech including Toyota Safety Sense. With a spacious interior, smooth ride, and up to 5,000 lbs towing capacity, it’s perfect for both daily driving and road trips.",
      image: "highlander/highlander2017_1.jpg",
      tumb1: "highlander/highlander2017_2.jpg",
      tumb2: "highlander/highlander2017_3.jpg",
      tumb3: "highlander/highlander2017_4.jpg"
    },
    {
      id: 2,
      name: "2018 Toyota Highlander",
      feature: "2018 Toyota Highlander – Blue Exterior, Grey Interior Smooth, spacious, and ready for Nigerian roads.",
      description:
        "2018 Toyota Highlander Spacious 3-row SUV with V6 power, available AWD, Toyota Safety Sense, touchscreen, and seating for 7–8. Comfortable, reliable, and perfect for family trips.",
      image: "highlander2018/highlander2018_1.jpg",
      tumb1: "highlander2018/highlander2018_2.jpg",
      tumb2: "highlander2018/highlander2018_3.jpg",
      tumb3: "highlander2018/highlander2018_4.jpg"
    },
    {
      id: 28,
      name: "2019 Toyota Highlander",
      feature: "2019 Toyota Highlander Black exterior with Tan interior – the perfect combo of style & class",
      description:
        "2019 Toyota Highlander Reliable 3-row SUV with V6 engine, available AWD, Toyota Safety Sense, touchscreen, and seating for up to 8. Comfortable, safe, and ideal for families.",
      image: "highlander2019/highlander2019_1.jpg",
      tumb1: "highlander2019/highlander2019_2.jpg",
      tumb2: "highlander2019/highlander2019_3.jpg",
      tumb3: "highlander2019/highlander2019_4.jpg"
    },
    {
      id: 29,
      name: "🚨 New Arrival Alert- 2024 Toyota Grand Highlander Limited AWD",
      feature: "New Arrival Alert- 2024 Toyota Grand Highlander Limited AWD! Sleek Black Exterior Premium Gray Interior",
      description:
        "2024 Toyota Grand Highlander Limited AWD Premium 3-row SUV with turbocharged power, AWD, leather interior, panoramic roof, JBL audio, heated/ventilated seats, and Toyota Safety Sense. Spacious, tech-packed, and road-trip ready.",
      image: "highlander2024/highlander2024_1.jpg",
      tumb1: "highlander2024/highlander2024_2.jpg",
      tumb2: "highlander2024/highlander2024_3.jpg",
      tumb3: "highlander2024/highlander2024_4.jpg"
    },

    {
      id: 31,
      name: "2012 Toyota Venza",
      feature: "New Arrival Alert- 2024 Toyota Grand Highlander Limited AWD! Sleek Black Exterior Premium Gray Interior",
      description:
        "2012 Toyota Venza Versatile midsize crossover with 4-cylinder or V6 engine options, available AWD, spacious interior, and smooth ride. Reliable and practical for daily driving and family use.",
      image: "venza/venza_1.jpg",
      tumb1: "venza/venza_2.jpg",
      tumb2: "venza/venza_3.jpg",
      tumb3: "venza/venza_4.jpg"
    },

    {
      id: 26, 
      name: "2025 Toyota Sienna",
      feature: " 2025 Toyota Sienna Black Exterior, Grey Interior Smooth, spacious, and ready for Nigerian roads. ",
      description:
        "2025 Toyota Sienna White exterior with black interior. A stylish and spacious minivan offering comfort, advanced tech, and great fuel efficiency—perfect for families and long trips.",
      image: "seina2025/seina2025_1.jpg",
      tumb1: "seina2025/seina2025_2.jpg",
      tumb2: "seina2025/seina2025_3.jpg",
      tumb3: "seina2025/seina2025_4.jpg"
    },

      {
      id: 33, 
      name: "2025 Toyota Sienna",
      feature: " 2025 Toyota Sienna Black Exterior, Grey Interior Smooth, spacious, and ready for Nigerian roads. ",
      description:
        "2025 Toyota Sienna White exterior with black interior. A stylish and spacious minivan offering comfort, advanced tech, and great fuel efficiency—perfect for families and long trips.",
      image: "seina/seina1.jpg",
      tumb1: "seina/seina2.jpg",
      tumb2: "seina/seina3.jpg",
      tumb3: "seina/seina4.jpg"
    },


    {
      id: 32, 
      name: "2021 Toyota Sienna",
      feature: " 2021 Toyota Sienna – Grey Exterior, Grey Interior Smooth, spacious, and ready for Nigerian roads. ",
      description:
        "2021 Toyota Sienna The 2021 Toyota Sienna is a stylish, fuel-efficient hybrid minivan offering up to 36 MPG combined. With seating for 7 or 8, available all-wheel drive, and advanced safety features like Toyota Safety Sense 2.0, it’s perfect for families on the go. Modern tech, a spacious interior, and bold design make it a smart and versatile choice.",      
      image: "seina2021/seina2021_1.jpg",
      tumb1: "seina2021/seina2021_2.jpg",
      tumb2: "seina2021/seina2021_3.jpg",
      tumb3: "seina2021/seina2021_4.jpg"
    },
    
    {
      id: 6, 
      name: "2021 Toyota Sienna",
      feature: " 2021 Toyota Sienna – Grey Exterior, Grey Interior Smooth, spacious, and ready for Nigerian roads. ",
      description:
        "2021 Toyota Sienna The 2021 Toyota Sienna is a stylish, fuel-efficient hybrid minivan offering up to 36 MPG combined. With seating for 7 or 8, available all-wheel drive, and advanced safety features like Toyota Safety Sense 2.0, it’s perfect for families on the go. Modern tech, a spacious interior, and bold design make it a smart and versatile choice.",      
      image: "seina2021/seina2021_1.jpg",
      tumb1: "seina2021/seina2021_2.jpg",
      tumb2: "seina2021/seina2021_3.jpg",
      tumb3: "seina2021/seina2021_4.jpg"
    },
    
    {
      id: 25,
      name: "2021 Toyota RAV4-LE Spot utility",
      feature: " 2021 Toyota RAV4-LE Spot utility 4D Exterior, Grey Interior Silver",
      description:
        "2021 Toyota RAV4 LE Sport Utility 4DExterior: Grey | Interior: SilverReliable and fuel-efficient SUV with a sleek grey exterior and clean silver interior. Offers spacious seating, modern safety features, and a smooth ride—perfect for daily driving or weekend getaways.",
      image: "rav4/rav46.jpg",
      tumb1: "rav4/rav43.jpg",
      tumb2: "rav4/rav47.jpg",
      tumb3: "rav4/rav41.jpg"
    },
  ],

  Mercedes: [
    {
      id: 23,
      name: "2019 Mercedes Benz G63",
      feature: " Sport Utility 4D White exterior Red luxury interior",
      description:
        "The 2019 Mercedes-Benz G63 AMG is a luxury performance SUV that combines rugged off-road heritage with modern luxury. It has a 4.0L twin-turbo V8 engine making 577 hp, paired with a 9-speed automatic and all-wheel drive. It goes 0–60 mph in about 4.5 seconds and has a top speed of up to 149 mph.",
      image: "benz/benz4.jpg",
      tumb1: "benz/benz1.jpg",
      tumb2: "benz/benz6.jpg",
      tumb3: "benz/benz7.jpg"
    },
  ],
  
  Jeep: [
    {
      id: 24,
      name: "2021 Jeep Grand Cherokee",
      feature: " Limited Sport Utility 4D - black exterior  gold interior",
      description:
        "The 2021 Jeep Grand Cherokee Limited is a midsize SUV that blends comfort, capability, and style. It comes with a 3.6L V6 engine (295 hp) and an 8-speed automatic, with available 4x4 for off-road use. Inside, it offers leather-trimmed seats, an 8.4-inch touchscreen with Apple CarPlay/Android Auto, premium audio, and advanced safety features like blind-spot monitoring and adaptive cruise control.",
      image: "jeep/jeep3.jpg",
      tumb1: "jeep/jeep2.jpg",
      tumb2: "jeep/jeep1.jpg",
      tumb3: "jeep/jeep4.jpg"
    },
  ],
};

export default product;
